import React from 'react';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { layoutConfig } from 'config/table-configs/order-rx-list';

const _orderDetailsPrescriptions = ( props ) => {
    return (
        <div className='ui-order-details-prescriptions'>
            <TableSearchWidget
                layoutConfig = { layoutConfig }
                templateType = 'inline'
                onActionClick={ props.onActionClick }
                tableResponse = { props.componentData }
                requestPayload={ props.requestPayload }
                disablePagination={ true }
            />
        </div>
    );
};

// set display name
_orderDetailsPrescriptions.displayName = 'orderDetailsPrescriptions';

// set default props
_orderDetailsPrescriptions.defaultProps = {};

// prop types
_orderDetailsPrescriptions.propTypes = {};

/*************************************** */

const orderDetailsPrescriptionsPreloader = ( ) => {
    return (
        <div className='ui-order-details-prescriptions-preloaderr'>
            <TableSearchInlineWidgetPreloader
                className='ui-order-details-prescriptions-preloader__table-preloader'
            />
        </div>
    );
};

// set display name
orderDetailsPrescriptionsPreloader.displayName = 'orderDetailsPrescriptionsPreloader';

// set default props
orderDetailsPrescriptionsPreloader.defaultProps = {};

// prop types
orderDetailsPrescriptionsPreloader.propTypes = {};


/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { orderDetailsPrescriptions as OrderDetailsPrescriptions } from 'ui/views/widgets/orderDetailsPrescriptions';
 *
 * // render
 * <OrderDetailsPrescriptions propName='propValue'/>
 */
export const orderDetailsPrescriptions = withNetworkState( orderDetailsPrescriptionsPreloader, _orderDetailsPrescriptions );

